export const tenantConnections = {
  cannotCreate: "Mandantenverbindung könnte nicht erstellt werden",
  pleaseCheckIfDBExists:
    "Bitte überprüfen Sie, ob eine Datenbank vorhanden ist, bevor Sie den Mandanten erstellen"
};
